import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { useEffect, useState } from 'react'

export function PHProvider({ children }: { children: React.ReactNode }) {
	const [hydrated, setHydrated] = useState(false)

	useEffect(() => {
		posthog.init('phc_Yi5L7XXU9OtbKK52zdOqx90YdIwFyrk9cUojkHRVkSr', {
			api_host: 'https://us.i.posthog.com',
			defaults: '2025-05-24',
			autocapture: false,
			disable_session_recording: true,
			advanced_disable_feature_flags: true,
			disable_surveys: true,
		})

		setHydrated(true)
	}, [])

	if (!hydrated) return <>{children}</>
	return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}
